const MAXLENGTH = {
    USER: {
        ID: 20,
        PASSWORD: 20,
    }
}

export default MAXLENGTH;